import { withCompInfo } from '@wix/editor-elements-integrations'
import { AppWidgetPropsCSSVars, AppWidgetDefinition } from './AppWidget'
import { getHeightInPixels } from '@wix/editor-elements-common-utils'

export const css = withCompInfo<AppWidgetPropsCSSVars | {}, AppWidgetDefinition>()(
	['skin', 'compLayout', 'compSingleLayout', 'isOneDocMigrated'],
	({ skin, compLayout, compSingleLayout, isOneDocMigrated }) => {
		return skin === 'AppWidgetLoaderSkin'
			? { height: isOneDocMigrated ? `${getHeightInPixels(compSingleLayout)}px` : `${compLayout.height}px` }
			: {}
	}
)
